module.exports = __webpack_public_path__ + "static/img/15023B_6_R_20200710_fit.16667c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15023B_6_R_20200710_fit.png
// module id = sXgP
// module chunks = 0